import AuthSidebar from './AuthSidebar';

export default AuthSidebar;
